/**
 * Only these protocols are counted as links: http, https, ftp, mailto, tel.
 * Other schemes (e.g. javascript:, data:, #), relative paths, and merge tags are ignored.
 */
const ALLOWED_PROTOCOLS = [
  'http:',
  'https:',
  'ftp:',
  'mailto:',
  'tel:',
] as const;

function hasAllowedProtocol(href: string): boolean {
  const lower = href.trim().toLowerCase();
  return ALLOWED_PROTOCOLS.some((p) => lower.startsWith(p));
}

export interface ExtractedLink {
  href: string;
}

/**
 * Extracts links from HTML. A link is counted only if it has one of:
 * http, https, ftp, mailto, or tel.
 */
export function extractLinksFromHtml(html: string): ExtractedLink[] {
  if (!html || typeof html !== 'string') return [];

  const seen = new Set<string>();
  const results: ExtractedLink[] = [];

  // Match href="..." or href='...' (value can contain entities but not unescaped quote)
  const hrefRegex = /href\s*=\s*["']([^"']*)["']/gi;
  let match: RegExpExecArray | null;

  while ((match = hrefRegex.exec(html)) !== null) {
    const raw = match[1].trim();
    if (!raw) continue;

    const normalized = raw.replace(/\s+/g, ' ').trim();
    if (seen.has(normalized)) continue;
    seen.add(normalized);

    if (hasAllowedProtocol(normalized)) {
      results.push({ href: normalized });
    }
  }

  return results;
}
